import React from 'react';

const BackButton = ({ onClick }) => (
    <button onClick={onClick} className="clinic-dashboard-back">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 18l-6-6 6-6" />
        </svg>
        Back
    </button>
);

export default BackButton;
